import * as Tone from 'tone';

export class AudioEngine {
  constructor() {
    this.playerOsc = null;
    this.monsterOscs = new Map(); // Map monster id to oscillator
    this.isInitialized = false;
    this.filter = null;
    this.lfo = null;
  }

  async init() {
    if (this.isInitialized) return;

    // Start Tone.js audio context (requires user gesture)
    await Tone.start();
    console.log('Audio engine initialized');

    // Rhythmic pulse instead of drone
    this.playerSynth = new Tone.MembraneSynth({
      pitchDecay: 0.05,
      octaves: 2,
      volume: -12
    }).toDestination();

    // Background rhythm track
    this.bass = new Tone.FMSynth({
      harmonicity: 0.5,
      modulationIndex: 2,
      volume: -20
    }).toDestination();

    // Start rhythm loop
    this.startRhythmLoop();

    this.isInitialized = true;
  }

  startRhythmLoop() {
    Tone.Transport.bpm.value = 120;

    // Kick drum on beats 1 and 3
    this.kickLoop = new Tone.Loop((time) => {
      this.bass.triggerAttackRelease('C1', '8n', time);
    }, '2n');
    this.kickLoop.start(0);

    Tone.Transport.start();
  }

  setPlayerFrequency(frequency) {
    // Store for visual feedback only
    this.currentPlayerFreq = frequency;
  }

  spawnMonsterOscillator(monster) {
    if (!this.isInitialized) return;

    // Play spawn sound effect - short blip
    const blip = new Tone.Synth({
      oscillator: { type: 'sine' },
      envelope: {
        attack: 0.01,
        decay: 0.1,
        sustain: 0,
        release: 0.1
      },
      volume: -8
    }).toDestination();

    blip.triggerAttackRelease(monster.frequency, '16n');
    setTimeout(() => blip.dispose(), 200);

    // Store monster data (no continuous sound)
    this.monsterOscs.set(monster.id, { frequency: monster.frequency });
  }

  killMonster(monster) {
    if (!this.monsterOscs.has(monster.id)) return;

    // Satisfying kill sound - explosion
    const explosion = new Tone.MembraneSynth({
      pitchDecay: 0.1,
      octaves: 4,
      volume: -6
    }).toDestination();

    explosion.triggerAttackRelease('C2', '8n');
    setTimeout(() => explosion.dispose(), 500);

    this.monsterOscs.delete(monster.id);
  }

  updateVolumes() {
    // No-op now (no continuous sounds)
  }

  update(gameState) {
    // Play rhythmic feedback when matching
    if (gameState.matchState && gameState.matchState.monsters.length > 0) {
      if (!this.isMatching) {
        this.isMatching = true;
        this.playMatchSound();
      }
    } else {
      this.isMatching = false;
    }
  }

  playMatchSound() {
    // Satisfying "lock" sound - snappy high synth
    const lock = new Tone.Synth({
      oscillator: { type: 'triangle' },
      envelope: {
        attack: 0.001,
        decay: 0.1,
        sustain: 0,
        release: 0.1
      },
      volume: -8
    }).toDestination();

    lock.triggerAttackRelease('G4', '16n');
    setTimeout(() => lock.dispose(), 200);
  }

  stopAll() {
    Tone.Transport.stop();

    if (this.kickLoop) {
      this.kickLoop.stop();
      this.kickLoop.dispose();
    }

    if (this.bass) {
      this.bass.dispose();
    }

    if (this.playerSynth) {
      this.playerSynth.dispose();
    }

    this.monsterOscs.clear();
  }
}
